import { createAction } from 'app-components/flux/core/actionHelpers';

export const getInvestmentsNewsfeed = createAction(
  'GET_INVESTMENTS_NEWSFEED',
  (payload) => payload,
  (payload, metadata) => metadata,
);
export const getInvestmentsNewsfeedSuccess = createAction(
  'GET_INVESTMENTS_NEWSFEED_SUCCESS',
  (payload) => payload,
  (payload, metadata) => metadata,
);
export const getInvestmentsNewsfeedFailure = createAction('GET_INVESTMENTS_NEWSFEED_FAILURE');
